import { useCallback } from 'react';
import { prop } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector, usePageSelector } from 'js/store/hooks';

export const useNavigateToPopupBackgroundPage = () => {
    const navigate = useNavigate();
    const rootPage = useAppSelector(prop('rootPage'));
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));
    const dynamicPagePath = usePageSelector(prop('dynamicPagePath'));

    return useCallback(() => {
        navigate(dynamicPagePath || popupBackgroundPagePath || rootPage);
    }, [dynamicPagePath, popupBackgroundPagePath, rootPage, navigate]);
};
